import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "9797fO+8ntFSJNbsb0BQnMM", "n_touchDesktop", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en
import n_touch from "./n_touch";
import { E_EventType, E_GameMode, E_GameState } from "../EnumBase";
import { _decorator, systemEvent, macro, SystemEventType, v3, v2 } from "cc";
import { App } from "../manager/App";
var ccclass = _decorator.ccclass,
    property = _decorator.property;

var n_touchDesktop = ccclass(_class = (_temp = /*#__PURE__*/function (_n_touch) {
  _inheritsLoose(n_touchDesktop, _n_touch);

  function n_touchDesktop() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _n_touch.call.apply(_n_touch, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_isMouseDown", false);

    _defineProperty(_assertThisInitialized(_this), "_keyArr", []);

    return _this;
  }

  var _proto = n_touchDesktop.prototype;

  _proto.start = function start() {
    systemEvent.on(SystemEventType.KEY_UP, this.onKeyUp, this);
    systemEvent.on(SystemEventType.KEY_DOWN, this.onKeyDown, this);
    systemEvent.on(SystemEventType.MOUSE_DOWN, this.onMouseDown, this);
    systemEvent.on(SystemEventType.MOUSE_MOVE, this.onMouseMove, this);
    systemEvent.on(SystemEventType.MOUSE_UP, this.onMouseUp, this);
    this.addEventListenr();
  };

  _proto.onDestroy = function onDestroy() {
    systemEvent.off(SystemEventType.KEY_UP, this.onKeyUp, this);
    systemEvent.off(SystemEventType.KEY_DOWN, this.onKeyDown, this);
    systemEvent.off(SystemEventType.MOUSE_DOWN, this.onMouseDown, this);
    systemEvent.off(SystemEventType.MOUSE_MOVE, this.onMouseMove, this);
    systemEvent.off(SystemEventType.MOUSE_UP, this.onMouseUp, this);
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    App.EventMgr.addEventLintener(E_EventType.Touch_BeginSelf, this.handle_beginTouch, this);
    App.EventMgr.addEventLintener(E_EventType.Touch_MoveSelf, this.handle_moveTouch, this);
    App.EventMgr.addEventLintener(E_EventType.Touch_EndSlef, this.handle_endTouch, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.onKeyUp = function onKeyUp(event) {
    if (this.isTouchEnable()) {
      switch (event.keyCode) {
        case macro.KEY.space:
          break;
      }
    }
  };

  _proto.onKeyDown = function onKeyDown(event) {
    if (this.isTouchEnable()) {
      switch (event.keyCode) {
        case macro.KEY.space:
          break;
      }
    }
  };

  _proto.onMouseDown = function onMouseDown(event) {
    if (this.isTouchEnable()) {}
  };

  _proto.handle_beginTouch = function handle_beginTouch(pos_touch) {
    this._pos_touch = pos_touch;
    this.correctWheelCenterPos();
  };

  _proto.onMouseMove = function onMouseMove(event) {
    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (this.isTouchEnable()) {
      this.handle_beginTouch(v2(event.getUILocation()));
    }
  };

  _proto.handle_moveTouch = function handle_moveTouch(pos_move) {
    this._pos_touch = pos_move;
    this.correctWheelCenterPos();
  };

  _proto.onMouseUp = function onMouseUp(event) {
    if (App.GameCtrl.gameMode == E_GameMode.Guide) return;

    if (this.isTouchEnable()) {}
  };

  _proto.handle_endTouch = function handle_endTouch() {
    this._isMouseDown = false;
  };

  _proto.correctWheelCenterPos = function correctWheelCenterPos() {
    var screenPos_actor = v3();
    var posW_actor = App.GameCtrl.n_gameUI.worldPosition.clone();
    posW_actor.add(screenPos_actor);
  };

  _proto.isTouchEnable = function isTouchEnable() {
    return App.GameCtrl.gameState == E_GameState.Gaming;
  };

  return n_touchDesktop;
}(n_touch), _temp)) || _class;

export { n_touchDesktop as default };

_cclegacy._RF.pop();